import { render, staticRenderFns } from "./ManufactureAmount.vue?vue&type=template&id=45b7a757&scoped=true&"
import script from "./ManufactureAmount.vue?vue&type=script&lang=js&"
export * from "./ManufactureAmount.vue?vue&type=script&lang=js&"
import style0 from "./ManufactureAmount.vue?vue&type=style&index=0&id=45b7a757&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7a757",
  null
  
)

export default component.exports